import { useEffect, useState } from 'react';
import useGlobalParams from '../../hooks/useGlobalParams';
import useUsers from '../../hooks/useUsers';
import useStatuses from '../../hooks/useStatuses';
import useMutateLead from '../../hooks/useMutateLead';
import { userFullName } from '../../utils/userUtils';

import Modal from 'react-bootstrap/Modal';
import Button from '../../common/Button/Button';

import LeadStatusDropdown from './LeadStatusDropdown';
import LeadAssigneeDropdown from './LeadAssigneeDropdown';

import './ExportModal.scss';

import './BulkEditModal.scss';

export default function ExportModal({ show, onHide, type, ids, onConfirm }) {
  const { categoryId, organizationId } = useGlobalParams();

  const { data: users } = useUsers({ organizationId, categoryId });
  const { data: statuses } = useStatuses({ categoryId });

  const { bulkEditMutation } = useMutateLead({ categoryId });

  const [selectedId, setSelectedId] = useState(null);
  const [processing, setProcessing] = useState(false);

  useEffect(() => {
    if (show) {
      setSelectedId(null);
      setProcessing(false);
    }
  }, [show]);

  const renderEdit = () => {
    switch (type) {
      case 'status':
        return <LeadStatusDropdown statuses={statuses} onChange={id => setSelectedId(id)} selectedId={selectedId} type='large' placeholder='Select a status' />

      case 'assignee':
        default:
        return <LeadAssigneeDropdown users={users} onChange={id => setSelectedId(id)} selectedUserId={selectedId} type='large' placeholder='Select an assignee' allowUnassigned />
    }
  }

  const onConfirmBulkEdit = id => {
    setProcessing(true);

    const data = { ids };

    const onSuccess = () => {
      onConfirm();
      onHide();
    }

    if (type === 'status') {
      data.status_id = id;
    }

    else if (type === 'assignee') {
      data.assigned_user_id = id === -1 ? null : id;
    }

    bulkEditMutation.mutate(data, { onSuccess });
  }

  const renderUpdateMessage = () => {
    switch (type) {
      case 'status':
        return <>The selected leads will be moved to <strong>{ statuses?.find(status => status.id === selectedId)?.name}</strong></>

      case 'assignee':
      default:
        return selectedId !== -1
        ? <>The selected leads will be assigned to <strong>{ userFullName(users?.find(user => user.id === selectedId)) }</strong></>
        : <>The selected leads will become <strong>unassigned.</strong></>
    }
  }

  return (
    <Modal className='__modal __bulk-edit-modal' show={show} onHide={onHide} backdrop='static'>
      <Modal.Header closeButton><h2>Edit { type === 'status' ? 'Status' : 'Assignee' }</h2></Modal.Header>
      <Modal.Body>
        <div className='edit-row'>
          <div className='edit-title'>{ type === 'status' ? 'Status' : 'Assignee' }</div>
          { renderEdit() }
        </div>
        { selectedId && <div className='update-message'>{ renderUpdateMessage() }</div> }
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={processing} className='cancel' onClick={onHide}>Cancel</Button>
        <Button loading={processing} className='confirm' disabled={!selectedId} onClick={() => onConfirmBulkEdit(selectedId)}>Bulk Edit</Button>
      </Modal.Footer>
    </Modal>
  );
}
